// extracted by mini-css-extract-plugin
export default {"container":"xt-z","heading":"yt-z","text":"zt-z","info":"At-z","link":"Bt-z","fullMaxWidth":"Ct-z"};